import React, { useEffect, useState } from 'react';
// import { Rate } from 'antd';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { listPromotions } from "../function/promotion";
import { useNavigate } from 'react-router-dom';
import './ProductCardHome.css';

const ProductCardHome = ({ product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [hasPromotion, setHasPromotion] = useState(false);
  const [discountedPrice, setDiscountedPrice] = useState(null);

  const { _id, title, images, price } = product;

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const res = await listPromotions();
        const promotions = res.data;
        const productPromotion = promotions.find((promotion) =>
          promotion.products.some((p) => p._id === product._id)
        );
        if (productPromotion) {
          setHasPromotion(true);
          const discount = productPromotion.discount;
          setDiscountedPrice(price - (price * discount) / 100);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchPromotions();
  }, [product, price]);

  const handleAddToCart = (e) => {
    e.stopPropagation();
    let cart = [];
    if (localStorage.getItem('cart')) {
      cart = JSON.parse(localStorage.getItem('cart'));
    }
    cart.push({
      ...product,
      count: 1,
      discountedPrice: discountedPrice !== null ? discountedPrice : price,
    });
    const unique = _.uniqWith(cart, _.isEqual);
    localStorage.setItem('cart', JSON.stringify(unique));
    dispatch({ type: 'ADD_TO_CART', payload: unique });
    dispatch({ type: 'SET_VISIBLE', payload: true });
  };

  const fmt = (val) =>
    new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(val);

  return (
    <div className="product-card-home-container">
      <div
        className={`product-card-home ${isHovered ? 'hovered' : ''}`}
        onClick={() => navigate(`/product/${_id}`)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {hasPromotion && <div className="ribbon">Promotion</div>}

        <img
          className="product-card-home-image"
          src={images && images.length ? images[0].url : ''}
          alt={title}
        />

        <div className="product-card-home-body">
          <h5>{title}</h5>

          <div className="product-price">
            {discountedPrice ? (
              <>
                <span className="price-original">{fmt(price)}</span>
                <span className="price-discount">{fmt(discountedPrice)}</span>
              </>
            ) : (
              <h4>{fmt(price)}</h4>
            )}
          </div>

          {/* <div className="rating-container">
            {product.averageRating > 0 && (
              <Rate disabled value={product.averageRating} style={{ fontSize: 10 }} />
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProductCardHome;